import React, { memo, useMemo } from 'react'
import { Grid } from 'transfix-ui/core'
import { IEquipment, IFacilityAppointment } from 'types'
import { getEligibleTime, getMinutes } from 'utils/accessorialHelpers'

interface IRequestSummaryProps {
  startDateTime: string
  endDateTime: string
  appointment?: IFacilityAppointment
  equipment: IEquipment
  className: string
}

export const RequestSummary = memo<IRequestSummaryProps>(
  ({ appointment, className, endDateTime, startDateTime }) => {
    const minutes = useMemo(
      () =>
        getMinutes({
          startDateTime,
          endDateTime,
          appointment,
        }),
      [appointment, endDateTime, startDateTime]
    )

    const eligibleTime = useMemo(() => getEligibleTime(minutes), [minutes])
    return (
      <Grid container>
        <Grid item md={6} xs={6} className={className}>
          <strong>Detention-eligible time</strong>
        </Grid>
        <Grid item md={6} xs={6}>
          <strong className='fr' data-test='detention-eligible-time'>
            {eligibleTime}
          </strong>
        </Grid>
      </Grid>
    )
  }
)
